import { API } from '../../../../../../vendor/api';
export const get = async (data) => {
    return API.institution.getInstitutionLocations(data);
};
export const create = async (data) => {
    return API.institution.createInstitutionLocations(data);
};
export const edit = async (data) => {
    return API.institution.editInstitutionLocations(data);
};
export const remove = async (locationId) => {
    await API.institution.deleteInstitutionLocations(locationId);
};
export const updateLocationForSharedRoom = async (data) => {
    await API.room.update(data);
};
export const updateLocationForManageUsers = async (data) => {
    await API.institution.updateInstitutionMembership(data);
};
